import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-p2-setting-edit-view',
    templateUrl: './p2-setting-edit-view.component.html',
    styleUrls: ['./p2-setting-edit-view.component.css'],
})
export class P2SettingEditViewComponent {
    public stateParams: { p2_setting_keyno: string };

    constructor(private state: StateService) {
        this.stateParams = this.state.getStateParams() as { p2_setting_keyno: string };
    }

    public onSubmit() {
        this.state.back();
    }
}
